export default __webpack_public_path__ + "static/media/005-clipboards.0cf22fa8.png";